document.addEventListener('DOMContentLoaded', function () {

  try {
    document.querySelectorAll('.split-reveal').forEach(function (el) {
      var words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words.map(function (w, i) {
        return '<span class="split-word" style="--i:' + i + '"><span>' + w + '&nbsp;</span></span>';
      }).join('');
    });
  } catch (err) { console.error('[stadion] split-text error', err); }

  try {
    var revealEls = document.querySelectorAll('.reveal, .split-reveal');
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });
      revealEls.forEach(function (el) { observer.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('in-view'); });
    }
  } catch (err) { console.error('[stadion] scroll-reveal error', err); }

  try {
    var toggle = document.querySelector('[data-menu-toggle]');
    var drawer = document.querySelector('[data-mobile-drawer]');
    var closeBtn = document.querySelector('[data-close-drawer]');
    if (toggle && drawer) {
      toggle.addEventListener('click', function () { drawer.classList.add('open'); });
    }
    if (closeBtn && drawer) {
      closeBtn.addEventListener('click', function () { drawer.classList.remove('open'); });
    }
    if (drawer) {
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { drawer.classList.remove('open'); });
      });
    }
  } catch (err) { console.error('[stadion] mobile-drawer error', err); }

  try {
    var popup = document.querySelector('.email-popup-overlay');
    if (popup) {
      var dismissed = false;
      try { dismissed = !!localStorage.getItem('stadion_popup_dismissed'); } catch (e) {}
      var box = popup.querySelector('.email-popup');
      var delay = box && box.dataset.delay ? parseInt(box.dataset.delay, 10) : 4000;
      var justSubmitted = popup.querySelector('.email-popup-success');

      if (justSubmitted) {
        popup.classList.add('open');
        try { localStorage.setItem('stadion_popup_dismissed', '1'); } catch (e) {}
      } else if (!dismissed) {
        setTimeout(function () { popup.classList.add('open'); }, delay);
      }

      var dismiss = function () {
        popup.classList.remove('open');
        try { localStorage.setItem('stadion_popup_dismissed', '1'); } catch (e) {}
      };

      var popupClose = popup.querySelector('.email-popup-close');
      if (popupClose) { popupClose.addEventListener('click', dismiss); }
      popup.addEventListener('click', function (e) {
        if (e.target === popup) { dismiss(); }
      });
    }
  } catch (err) { console.error('[stadion] email-popup error', err); }

  try {
    /* ---- swipeable / clickable product gallery (product detail page) ---- */
    document.querySelectorAll('.pdp-gallery-wrap').forEach(function (wrap) {
      var gallery = wrap.querySelector('.pdp-gallery');
      var track = wrap.querySelector('.pdp-gallery-track');
      var slides = wrap.querySelectorAll('.pdp-gallery-slide');
      var dots = wrap.querySelectorAll('.pdp-dot');
      var prevBtn = wrap.querySelector('.pdp-nav-btn.prev');
      var nextBtn = wrap.querySelector('.pdp-nav-btn.next');
      if (!gallery || !track || slides.length < 2) return;

      var index = 0;
      var startX = 0;
      var deltaX = 0;
      var dragging = false;

      function goTo(i) {
        index = Math.max(0, Math.min(slides.length - 1, i));
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        dots.forEach(function (d, di) { d.classList.toggle('active', di === index); });
        if (prevBtn) { prevBtn.disabled = index === 0; }
        if (nextBtn) { nextBtn.disabled = index === slides.length - 1; }
      }

      dots.forEach(function (d, di) {
        d.addEventListener('click', function () { goTo(di); });
      });

      if (prevBtn) { prevBtn.addEventListener('click', function () { goTo(index - 1); }); }
      if (nextBtn) { nextBtn.addEventListener('click', function () { goTo(index + 1); }); }

      function start(x) {
        dragging = true; startX = x; deltaX = 0;
        track.style.transition = 'none';
      }
      function move(x) {
        if (!dragging) return;
        deltaX = x - startX;
        track.style.transform = 'translateX(calc(-' + (index * 100) + '% + ' + deltaX + 'px))';
      }
      function end() {
        if (!dragging) return;
        dragging = false;
        track.style.transition = '';
        if (deltaX < -60) { goTo(index + 1); }
        else if (deltaX > 60) { goTo(index - 1); }
        else { goTo(index); }
        deltaX = 0;
      }

      gallery.addEventListener('touchstart', function (e) { start(e.touches[0].clientX); }, { passive: true });
      gallery.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
      gallery.addEventListener('touchend', end);

      gallery.addEventListener('mousedown', function (e) {
        if (e.target.closest && e.target.closest('.pdp-nav-btn')) { return; }
        start(e.clientX); e.preventDefault();
      });
      window.addEventListener('mousemove', function (e) { move(e.clientX); });
      window.addEventListener('mouseup', end);

      goTo(0);
    });
  } catch (err) { console.error('[stadion] product-gallery error', err); }

  try {
    /* ---- swipeable / toggleable thumbnails inside collection grid cards ---- */
    document.querySelectorAll('.rd-item-visual[data-gallery]').forEach(function (gallery) {
      var track = gallery.querySelector('.rd-item-track');
      var slides = gallery.querySelectorAll('.rd-item-slide');
      var dots = gallery.querySelectorAll('.rd-item-dot');
      var prevBtn = gallery.querySelector('.rd-item-nav.prev');
      var nextBtn = gallery.querySelector('.rd-item-nav.next');
      var link = gallery.closest('a');
      if (!track || slides.length < 2) return;

      var index = 0, startX = 0, deltaX = 0, dragging = false, wasDragged = false;

      function goTo(i) {
        index = Math.max(0, Math.min(slides.length - 1, i));
        track.style.transform = 'translateX(-' + (index * 100) + '%)';
        dots.forEach(function (d, di) { d.classList.toggle('active', di === index); });
        if (prevBtn) { prevBtn.disabled = index === 0; }
        if (nextBtn) { nextBtn.disabled = index === slides.length - 1; }
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          goTo(index - 1);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          goTo(index + 1);
        });
      }

      function start(x) {
        dragging = true; wasDragged = false; startX = x; deltaX = 0;
        track.style.transition = 'none';
      }
      function move(x) {
        if (!dragging) return;
        deltaX = x - startX;
        if (Math.abs(deltaX) > 8) { wasDragged = true; }
        track.style.transform = 'translateX(calc(-' + (index * 100) + '% + ' + deltaX + 'px))';
      }
      function end() {
        if (!dragging) return;
        dragging = false;
        track.style.transition = '';
        if (deltaX < -40) { goTo(index + 1); }
        else if (deltaX > 40) { goTo(index - 1); }
        else { goTo(index); }
        deltaX = 0;
      }

      gallery.addEventListener('touchstart', function (e) { start(e.touches[0].clientX); }, { passive: true });
      gallery.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
      gallery.addEventListener('touchend', end);

      gallery.addEventListener('mousedown', function (e) {
        if (e.target.closest && e.target.closest('.rd-item-nav')) { return; }
        start(e.clientX);
      });
      window.addEventListener('mousemove', function (e) { move(e.clientX); });
      window.addEventListener('mouseup', end);

      if (link) {
        link.addEventListener('click', function (e) {
          if (wasDragged) { e.preventDefault(); }
        });
      }

      goTo(0);
    });
  } catch (err) { console.error('[stadion] collection-thumb-gallery error', err); }

  try {
    var isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (isFinePointer) {
      var cursor = document.createElement('div');
      cursor.className = 'stadion-cursor active';
      cursor.style.left = '50%';
      cursor.style.top = '50%';
      document.body.appendChild(cursor);

      document.addEventListener('mousemove', function (e) {
        cursor.style.left = e.clientX + 'px';
        cursor.style.top = e.clientY + 'px';
        cursor.classList.add('active');
      });
      document.documentElement.addEventListener('mouseleave', function () {
        cursor.classList.remove('active');
      });
      document.documentElement.addEventListener('mouseenter', function () {
        cursor.classList.add('active');
      });

      var HOVER_SELECTOR = 'a, button, .product, .rd-item';
      document.addEventListener('mouseover', function (e) {
        if (e.target && e.target.closest && e.target.closest(HOVER_SELECTOR)) {
          cursor.classList.add('hover');
        }
      });
      document.addEventListener('mouseout', function (e) {
        var toEl = e.relatedTarget;
        if (!toEl || !toEl.closest || !toEl.closest(HOVER_SELECTOR)) {
          cursor.classList.remove('hover');
        }
      });

      document.addEventListener('mousemove', function (e) {
        var magnet = e.target && e.target.closest ? e.target.closest('.magnetic') : null;
        document.querySelectorAll('.magnetic').forEach(function (el) {
          if (el !== magnet) { el.style.transform = 'translate(0,0)'; }
        });
        if (magnet) {
          var rect = magnet.getBoundingClientRect();
          var x = e.clientX - rect.left - rect.width / 2;
          var y = e.clientY - rect.top - rect.height / 2;
          magnet.style.transform = 'translate(' + (x * 0.3) + 'px,' + (y * 0.3) + 'px)';
        }
      });
    }
  } catch (err) { console.error('[stadion] cursor error', err); }
});
